module.exports = "/images/seattle-hero.png";